<template>
  <section class="q-pa-sm">
    <q-expansion-item :label="$t('Search location labels')">
      <q-form @submit="search(false)">
        <q-input v-model="query" :label="$t('Location label')" :disable="busy" />
        <q-btn type="submit" :label="$t('Search')" :disable="busy || !query" />
      </q-form>
      <ul><li v-for="item in items" :key="item.id">
        <q-btn flat :label="`${item.value} — ${item.internalCode} (${item.state})`" @click="$emit('select', item)" />
      </li></ul>
      <q-btn v-if="next" :label="$t('Load more')" :disable="busy" @click="search(true)" />
    </q-expansion-item>
    <q-expansion-item :label="$t('Import location labels')">
      <p>{{ $t('Paste one existing location code and label per line, separated by a tab. Maximum 200 rows.') }}</p>
      <q-input v-model="text" type="textarea" :disable="busy" :label="$t('Location codes and labels')" />
      <q-btn :label="$t('Preview import')" :disable="busy || !text" @click="preview" />
      <ul><li v-for="row in previewRows" :key="row.row">{{ row.row }}: {{ row.place }} ← {{ row.raw }}</li></ul>
      <ul><li v-for="row in errors" :key="row.row">{{ row.row }}: {{ row.reason }}</li></ul>
      <q-btn v-if="token" :label="$t('Apply reviewed import')" :disable="busy" @click="apply" />
      <p v-if="outcomes.length">{{ $t('Linked labels') }}: {{ outcomes.length }}</p>
    </q-expansion-item>
    <div v-if="error" role="alert" class="text-negative">{{ error }}</div>
  </section>
</template>
<script>
import { parseAliasImport } from './location-identifiers.mjs';
export default {
  props: { warehouseId: { type: [String, Number], required: true } },
  emits: ['select', 'imported'],
  data() { return { text: '', query: '', items: [], next: null, token: null, previewRows: [], errors: [], outcomes: [], busy: false, error: '', generation: 0 }; },
  watch: {
    text() { this.token = null; this.previewRows = []; this.errors = []; this.outcomes = []; this.generation += 1; },
    warehouseId() { this.token = null; this.items = []; this.next = null; this.previewRows = []; this.errors = []; this.outcomes = []; this.generation += 1; },
    query() { this.items = []; this.next = null; this.generation += 1; },
  },
  beforeUnmount() { this.generation += 1; },
  methods: {
    async run(action, payload, accept) {
      if (this.busy) return;
      this.busy = true; this.error = ''; const generation = this.generation;
      try {
        const result = await this.$service.storagePlace.identifierRequest({ action, warehouse: this.warehouseId, ...payload });
        if (generation === this.generation) accept(result);
      } catch (error) { if (generation === this.generation) this.error = error.message || 'Request failed'; }
      finally { this.busy = false; }
    },
    search(more) { return this.run('search', { query: this.query, after: more ? this.next : 0 }, (result) => { this.items = more ? [...this.items, ...result.items] : result.items; this.next = result.next; }); },
    preview() {
      this.token = null; this.error = '';
      let rows;
      try { rows = parseAliasImport(this.text); } catch (error) { this.error = error.message; return; }
      this.run('preview', { rows }, (result) => { this.token = result.token; this.previewRows = result.rows; this.errors = result.errors; });
    },
    apply() { return this.run('apply', { token: this.token }, (result) => { this.outcomes = result.outcomes; this.token = null; this.$emit('imported'); }); },
  },
};
</script>
